export const filterValidStrings = (items?: string[] | null): string[] =>
  items?.filter((item): item is string => Boolean(item?.trim())) ?? [];
